import router from '@/router/router';
import * as types from '@/store/mutationTypes';
import { UserPermissions } from '@/utils/userInfo';
import authenticationService from '@/http/services/authenticationService';
import profileService from '@/http/services/profileService';

export const actions = {
    getProfile: async ({ commit }, payload) => {
        const profile = await profileService.getProfile(payload);

        commit(types.SET_PROFILE_INFO, profile);
    },

    editProfile: async ({ commit, dispatch }, payload) => {
        const { parentId } = payload;
        const updatedInfo = await profileService.editProfile(payload);

        commit(types.UPDATE_PROFILE, updatedInfo);
        dispatch('createNotification', { message: 'Profile information has been updated' });
        dispatch('getProfile', parentId);
    },

    changePassword: async ({ dispatch, commit }, payload) => {
        const userLogIn = {
            userName: payload.userName,
            password: payload.passwordForm.newPassword
        };

        await profileService.changePassword(payload);

        dispatch('createNotification', { message: 'Password has been changed' });

        const userInfo = await authenticationService.logIn(userLogIn);

        commit(types.SET_USER_INFO, userInfo);

        UserPermissions.setUserInfoToLocalStorage(userInfo);

        router.push({ name: 'PROFILE', params: router.currentRoute.params })
    },

    changeEmail: async ({ dispatch }, payload) => {
        await profileService.changeEmail(payload);

        dispatch('createNotification', { message: 'Please go to your email and confirm' });
    },

    getProfileNotificationsStatus: async ({ commit, dispatch }, payload) => {
        const notificationsStatus = await profileService.getProfileNotificationsStatus(payload);

        commit(types.SET_PROFILE_NOTIFICATIONS_STATUS, notificationsStatus);
    },

    changeProfileNotificationStatus: async({ commit, dispatch }, payload) => {

        const { title, description, status, parentId } = payload ;

       switch (description) {
           case 'emailOnAddingToWaitList':
               await profileService.changeEmailOnAddingToWaitListStatus({ parentId, status });

               dispatch('getProfileNotificationsStatus', parentId);
               dispatch('createNotification', { message: `Status "${title}" has been changed ` });
               break;
           case 'emailOnRemovingFromWaitList':
               await profileService.changeEmailOnRemovingFromWaitListStatus({ parentId, status });

               dispatch('getProfileNotificationsStatus', parentId);
               dispatch('createNotification', { message: `Status "${title}" has been changed ` });
               break;
           case 'emailOnSuccessfulEnrollment':
               await profileService.changeEmailOnSuccessfulEnrollmentStatus({ parentId, status });

               dispatch('getProfileNotificationsStatus', parentId);
               dispatch('createNotification', { message: `Status "${title}" has been changed ` });
               break;
           case 'emailOnScheduleChange':
               await profileService.changeEmailOnScheduleChangeStatus({ parentId, status });

               dispatch('getProfileNotificationsStatus', parentId);
               dispatch('createNotification', { message: `Status "${title}" has been changed ` });
               break;
       }
    },

    getAvatar: async ({ commit }, payload) => {
        const profileAvatar = await profileService.getAvatar(payload);

        commit(types.SET_PROFILE_AVATAR, profileAvatar);
    },

    uploadAvatar: async ({ commit, dispatch }, payload) => {
        const profileAvatar = await profileService.uploadAvatar(payload);

        commit(types.SET_PROFILE_AVATAR, profileAvatar.data);
        dispatch('createNotification', { message: `You have successfully changed your avatar` });
    },

    removeAvatar: async ({ commit, dispatch }, payload) => {
        await profileService.removeAvatar(payload);

        commit(types.SET_PROFILE_AVATAR, null);
        dispatch('createNotification', { message: `You have successfully remove your avatar` });
    },

    showHeadingAvatarLoading: ({ commit }, payload) => {
        commit(types.SET_HEADING_AVATAR_LOADING, payload);
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/profile/actions.js